import { useEffect } from "react";
import { useAuthStore } from "../store";
import socket from "../Utils/socketClient";

const SocketSync = () => {
  useEffect(() => {
    socket.on("teamDetailsTrigger", (payload) => {
      // console.log("📥 Received: teamDetailsTrigger", payload);
      if (
        payload &&
        typeof payload === "object" &&
        ("liveCountdownRunning" in payload || "liveCountdownOver" in payload)
      ) {
        const nextTrigger =
          typeof payload.timeStamp === "number"
            ? payload.timeStamp
            : Date.now();
        useAuthStore.setState({
          teamDetailsTrigger: nextTrigger,
          liveCountdownRunning: Boolean(payload.liveCountdownRunning),
          liveCountdownOver: Boolean(payload.liveCountdownOver),
          liveCountdownEndsAt:
            typeof payload.liveCountdownEndsAt === "number"
              ? payload.liveCountdownEndsAt
              : null,
        });
        return;
      }
      useAuthStore.setState({ teamDetailsTrigger: payload });
    });

    socket.on("selectedPlayerData", (data) => {
      // console.log("📥 Received: selectedPlayerData", data || "no name");
      useAuthStore.setState({ selectedPlayerData: data });
    });

    socket.on("clearSelectedPlayerData", () => {
      // console.log("📥 Received: clearSelectedPlayerData");
      useAuthStore.setState({ selectedPlayerData: null });
    });

    socket.on("livePlayerBidUpdate", (data) => {
      console.log("📥 Received: livePlayerBidUpdate", data);
      const payload = data?.data ?? data;
      const payloadPlayer =
        payload?.player ||
        payload?.playerData ||
        payload?.selectedPlayerData ||
        payload?.Player__r ||
        null;

      useAuthStore.setState((state: any) => ({
        liveBidData: payload,
        selectedPlayerData: state?.selectedPlayerData || payloadPlayer || null,
      }));
    });

    socket.on("clearLiveBidData", () => {
      // console.log("📥 Received: clearSelectedPlayerData");
      useAuthStore.setState({ liveBidData: null });
    });

    // squad list
    socket.on("liveTeamDetails", (id) => {
      useAuthStore.setState({ liveTeamId: id });
    });
  
    const clearLiveTeamHandler = () => {
      useAuthStore.setState({ liveTeamId: null });
    };

    socket.on("clearLiveTeamId", clearLiveTeamHandler);
    socket.on("clearLiveTeamDetails", clearLiveTeamHandler);

    socket.on("startLiveCountdown", (payload) => {
      useAuthStore.setState({
        liveCountdownRunning: true,
        liveCountdownOver: false,
        liveCountdownEndsAt:
          payload && typeof payload.endsAt === "number" ? payload.endsAt : null,
      });
    });

    socket.on("closeLiveCountdown", () => {
      useAuthStore.setState({
        liveCountdownRunning: false,
        liveCountdownOver: false,
        liveCountdownEndsAt: null,
      });
    });

    socket.on("liveCountdownOver", () => {
      useAuthStore.setState({
        liveCountdownRunning: false,
        liveCountdownOver: true,
        liveCountdownEndsAt: null,
      });
    });

    return () => {
      socket.off("teamDetailsTrigger");
      socket.off("selectedPlayerData");
      socket.off("clearSelectedPlayerData");
      socket.off("livePlayerBidUpdate");
      socket.off("clearLiveBidData");
      socket.off("liveTeamDetails");
      socket.off("clearLiveTeamId", clearLiveTeamHandler);
      socket.off("clearLiveTeamDetails", clearLiveTeamHandler);
      socket.off("startLiveCountdown");
      socket.off("closeLiveCountdown");
      socket.off("liveCountdownOver");
    };
  }, []);
  return null;
};

export default SocketSync;
